module.exports = __webpack_public_path__ + "img/specials-multislider-6040--infiniti.24866eb8.png";